import { CSSObject } from '@chakra-ui/react';

export const DrawerHeaderContainer: CSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  zIndex: 'popover',
  bgGradient: 'linear(180deg, gamma.500, gamma.700)',
  alignItems: 'center',
  px: '6',
  borderBottom: '4px',
  borderBottomColor: 'whiteAlpha.300',
  h: '16',
};

export const IconCircleOutline: CSSObject = {
  boxSize: '8',
};
